<template>
    <datatable :columns="columns" :source="getRecords" @selected="recordSelected"></datatable>
</template>

<script>
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import { UserDto, UserPermissionDto } from "./../../../dto/Dtos";
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"

    export default {
        props: {
            id: {
                type: String,
                required: false
            },
            value: {
                type: String,
                required: false

            }
        },
        mounted: function () {
            var dal = new Dal();
            dal.GetCarehomes().then(data => this.carehomes = data)
        },
        data: function () {
            var formatDate = Formatter.FormatDate;
            var that = this;
            return {
                carehomes: [],
                columns: [
                    {
                        name: "Name", render: function (data, type, row) {

                            return (row.firstName || "") + " " + (row.lastName || "")
                        }
                    }
                    , { name: "Email", data: "email" }
                    , { name: "Phone", data: "number" }
                    , {
                        name: "Permissions", render: function (data, type, row) {
                            console.log(row)
                            var permissions = row.userPermissions;
                            var result = "";
                            var first = true;
                            for (var permission of permissions) {
                                if (permission.permissionId == 3 || permission.permissionId == 5) {
                                    if (first) {
                                        first = false;
                                    }
                                    else {
                                        result += "<br/>"
                                    }
                                    result += "Manager : " + that.getCarehomeName(permission.carehomeId);
                                }
                            }
                            return result;
                        }
                    }
                ]
            }
        },
        methods: {

            getCarehomeName: function (carehomeId) {
                console.log("Carehomes ", this.carehomes, carehomeId)
                for (var ch of this.carehomes) {
                    if (ch.id == carehomeId) {
                        console.log("Carehome ----s ", ch)
                        return ch.name;
                    }
                }
                return "";
            },
            getRecords: function (callback) {
                var dal = new Dal();
                var carehomeId = this.id;

                dal.GetUsersForCarehome(carehomeId).then(data => {
                    var records = { data: data };
                    callback(records);
                });

            },

            recordSelected: function (record) {
                var id = record.id;
                this.$emit('input', record);
            }
        },
        components: {
            datatable,
            Formatter
        }
    }
</script>


// WEBPACK FOOTER //
// carehomeusertable.scp.html?32e94d62